import produce from "immer";
import { IStoreState } from "../../initialStoreState";
import { LoadState } from "../../../constants/enums";
import { AccountingBillActions } from ".";
import { initialAccountingBillState } from "./Bill.types";
import {
  CLEAR_ACCOUNTING_BILL,
  FETCH_ACCOUNTING_BILL_FAILURE,
  FETCH_ACCOUNTING_BILL_LIST_FAILURE,
  FETCH_ACCOUNTING_BILL_LIST_PROGRESS,
  FETCH_ACCOUNTING_BILL_LIST_SUCCESS,
  FETCH_ACCOUNTING_BILL_PROGRESS,
  FETCH_ACCOUNTING_BILL_SUCCESS,
  FETCH_BILL_PAYMENT_HISTORY_FAILED,
  FETCH_BILL_PAYMENT_HISTORY_PROGRESS,
  FETCH_BILL_PAYMENT_HISTORY_SUCCESS,
  UPDATE_BILL_LIST_RECONCILIATION_STATUS,
} from "./BillActions";

export const AccountingBillReducer = (
  state: IStoreState["accounting"]["bill"] = initialAccountingBillState,
  action: AccountingBillActions
) => {
  switch (action.type) {
    case FETCH_ACCOUNTING_BILL_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_ACCOUNTING_BILL_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.data = data;
      });
      return newState;
    }

    case FETCH_ACCOUNTING_BILL_FAILURE: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.error = errorMessage;
      });
      return newState;
    }

    case FETCH_ACCOUNTING_BILL_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.listLoading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_ACCOUNTING_BILL_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.listLoading = LoadState.Loaded;
        draftState.list = data;
      });
      return newState;
    }

    case FETCH_ACCOUNTING_BILL_LIST_FAILURE: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.listLoading = LoadState.Failed;
      });
      return newState;
    }

    case FETCH_BILL_PAYMENT_HISTORY_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.billHistoryLoading = LoadState.InProgress;
        draftState.bill_history = initialAccountingBillState["bill_history"];
      });
      return newState;
    }

    case FETCH_BILL_PAYMENT_HISTORY_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.billHistoryLoading = LoadState.Loaded;
        draftState.bill_history = data;
      });
      return newState;
    }

    case FETCH_BILL_PAYMENT_HISTORY_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.billHistoryLoading = LoadState.Failed;
        draftState.error = errorMessage;
        draftState.bill_history = initialAccountingBillState["bill_history"];
      });
      return newState;
    }

    case UPDATE_BILL_LIST_RECONCILIATION_STATUS: {
      const { paymentIds, reconciled, reconciledDate } = action.payload;
      return produce(state, (draftState) => {
        paymentIds.forEach((id: number) => {
          const index = draftState.list.findIndex(x => x.accn_transaction_id === id);
          if (index > -1) {
            draftState.list[index].reconciled = reconciled;
            draftState.list[index].reconciled_date = reconciledDate;
          }
        });
      });
    }
    case CLEAR_ACCOUNTING_BILL: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.NotLoaded;
        draftState.data = initialAccountingBillState.data;
        draftState.error = null;
      });
      return newState;
    }

    default:
      return state;
  }
};
